const getElementByTwigIdentifier = (elementIdentifier: string) => {
    if (typeof document === 'undefined') return null;

    const escapedIdentifier =
        typeof CSS !== 'undefined' && typeof CSS.escape === 'function'
            ? CSS.escape(elementIdentifier)
            : elementIdentifier;

    const reactRootElement = Array.from(
        document.querySelectorAll<HTMLElement>(`[data-react-root="${escapedIdentifier}"]`)
    ).find(
        (element) =>
            !!element.dataset.widgetId ||
            element.dataset.widgetIsAvailable != null ||
            element.dataset.isCompanyOwner != null ||
            element.dataset.hasWidgetDetails != null
    );

    return (
        reactRootElement ??
        document.getElementById(elementIdentifier)
    );
};

const parseBooleanWidgetFlag = (value?: string) => value === '1' || value === 'true';

export const getWidgetDataFromTwig = (elementIdentifier: string) => {
    if (typeof document === 'undefined') {
        return {
            widgetId: null,
            isWidgetAvailable: false,
            isCompanyOwner: false,
            hasWidgetDetails: false,
        };
    }

    const widgetRoot = getElementByTwigIdentifier(elementIdentifier);

    return {
        widgetId: widgetRoot?.dataset?.widgetId ?? null,
        companyId: widgetRoot?.dataset?.companyId ?? null,
        isWidgetAvailable: parseBooleanWidgetFlag(widgetRoot?.dataset?.widgetIsAvailable),
        isCompanyOwner: parseBooleanWidgetFlag(widgetRoot?.dataset?.isCompanyOwner),
        hasWidgetDetails: parseBooleanWidgetFlag(widgetRoot?.dataset?.hasWidgetDetails),
        availableActionType: widgetRoot?.dataset?.availableActionType ?? null,
    };
};
